module.exports = __webpack_public_path__ + "static/media/bill-to-ship-to-show.9fc7cfca.png";